import { InsuranceType, MainPath } from "Constants/constants";

export const PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.TRAVEL}`;

interface TravelCoverage {
  group: TravelCoverageGroup;
  forInsuredOnly: boolean;
}

interface Coverages {
  [key: string]: TravelCoverage;
}

export enum TravelCoverageGroup {
  SUPER = "TRAVEL_SUPER",
  STANDARD = "TRAVEL_STANDARD",
}

export const travelCoverages: Coverages = {
  TRAVEL_STANDARD: {
    group: TravelCoverageGroup.STANDARD,
    forInsuredOnly: false,
  },
  TRAVEL_COVERAGE_FOR_INSURED_ONLY: {
    group: TravelCoverageGroup.STANDARD,
    forInsuredOnly: true,
  },
  TRAVEL_SUPER: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: false,
  },
  TRAVEL_SUPER_90_DAYS: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: false,
  },
  TRAVEL_SUPER_120_DAYS: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: false,
  },
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: true,
  },
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_90_DAYS: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: true,
  },
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_120_DAYS: {
    group: TravelCoverageGroup.SUPER,
    forInsuredOnly: true,
  },
};

export function isStandardCoverage(coverage: string): boolean {
  return travelCoverages[coverage]?.group === TravelCoverageGroup.STANDARD;
}

export function isSuperCoverage(coverage: string): boolean {
  return travelCoverages[coverage]?.group === TravelCoverageGroup.SUPER;
}
